import React, { useEffect } from "react";

const ComprasNotasCreditoPage = () => {
  useEffect(() => {
    document.title = "Compras - Notas de crédito | Saas";
  }, []);

  return (
    <div className="page-content">
      <div className="container-fluid">
        <div className="card">
          <div className="card-body">
            <h4 className="card-title mb-3">Notas de crédito</h4>
            <p className="text-muted mb-0">
              Desde acá vas a poder registrar y aplicar notas de crédito de proveedores para ajustar
              facturas existentes o saldos pendientes. Pronto se conectará con contabilidad para reflejar
              los movimientos automáticamente.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ComprasNotasCreditoPage;
